import React from 'react';

export const AmbientBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* 1. Deep Royal Purple & Violet Upper Horizon Nebula */}
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 w-[650px] h-[400px] rounded-full opacity-35 blur-[100px]"
        style={{
          background: 'radial-gradient(circle, #7c3aed 0%, #431407 10%, #1e1147 60%, transparent 100%)',
          willChange: 'transform',
        }}
      />

      {/* 2. Electric Cyan / Teal Reactor Edge Glow (Left) */}
      <div
        className="absolute top-1/4 -left-36 w-[380px] h-[380px] rounded-full opacity-25 blur-[95px]"
        style={{
          background: 'radial-gradient(circle, #00f2fe 0%, #0369a1 45%, #0e7490 70%, transparent 100%)',
          willChange: 'transform',
        }}
      />

      {/* 3. Magenta / Coral Energy Glow (Right) */}
      <div
        className="absolute top-1/3 -right-36 w-[360px] h-[360px] rounded-full opacity-20 blur-[90px]"
        style={{
          background: 'radial-gradient(circle, #ec4899 0%, #a21caf 50%, #581c87 75%, transparent 100%)',
          willChange: 'transform',
        }}
      />

      {/* 4. Warm Gold / Champagne Stars Starlight Field (Bottom Right) */}
      <div
        className="absolute bottom-1/4 -right-28 w-[380px] h-[380px] rounded-full opacity-20 blur-[95px]"
        style={{
          background: 'radial-gradient(circle, #fbbf24 0%, #b45309 45%, #78350f 70%, transparent 100%)',
          willChange: 'transform',
        }}
      />

      {/* 5. Electric Blue Lower Horizon Flow */}
      <div
        className="absolute -bottom-24 left-1/4 w-[450px] h-[280px] rounded-full opacity-20 blur-[85px]"
        style={{
          background: 'radial-gradient(circle, #38bdf8 0%, #1e1b4b 65%, transparent 100%)',
          willChange: 'transform',
        }}
      />

      {/* 6. Subtle Floating Starlight Dust / Quantum Particles */}
      <svg className="absolute inset-0 w-full h-full opacity-30" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="particleCyan" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00f2fe" stopOpacity="1" />
            <stop offset="100%" stopColor="#00f2fe" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="particleGold" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffd700" stopOpacity="1" />
            <stop offset="100%" stopColor="#ffd700" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="particlePurple" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#c084fc" stopOpacity="1" />
            <stop offset="100%" stopColor="#c084fc" stopOpacity="0" />
          </radialGradient>
        </defs>

        <circle cx="15%" cy="18%" r="1.5" fill="url(#particleCyan)" className="animate-pulse" />
        <circle cx="82%" cy="12%" r="2" fill="url(#particleGold)" className="animate-pulse" style={{ animationDelay: '1.2s' }} />
        <circle cx="48%" cy="28%" r="1.2" fill="url(#particlePurple)" />
        <circle cx="88%" cy="42%" r="1.8" fill="url(#particleCyan)" className="animate-pulse" style={{ animationDelay: '0.7s' }} />
        <circle cx="10%" cy="60%" r="2.2" fill="url(#particleGold)" style={{ animationDelay: '2.1s' }} />
        <circle cx="75%" cy="72%" r="1.5" fill="url(#particlePurple)" className="animate-pulse" style={{ animationDelay: '1.5s' }} />
        <circle cx="28%" cy="85%" r="2" fill="url(#particleCyan)" style={{ animationDelay: '0.4s' }} />
        <circle cx="65%" cy="92%" r="1.6" fill="url(#particleGold)" className="animate-pulse" style={{ animationDelay: '2.5s' }} />
      </svg>
    </div>
  );
};
